// extracted by mini-css-extract-plugin
export default {"zone3d":"ModelZone_zone3d__JvS5B","canvasContainer":"ModelZone_canvasContainer__9kbl-","popup3d":"ModelZone_popup3d__4GGq-"};